import React from "react";
import AddComandaForm from "./AddComandaForm";

const AddComanda = ({ show, setShow }) => {
  const handleShow = () => {
    setShow(!show);
  };
  return (
    <>
      <div className="">
        <button className="btn btn-dark" onClick={handleShow}>
          {show ? "Ocultar Form" : "Agregar Comanda"}
        </button>
      </div>
      {show && (
        <div className="mt-2">
          <AddComandaForm setShow={setShow} />
        </div>
      )}
    </>
  );
};
export default AddComanda;
